export enum ScheduleValidationLevel {
  EMPLOYEE = 'EMPLOYEE',
  WEEK = 'WEEK',
  DAY = 'DAY',
  SHIFTS = 'SHIFTS'
}
